@if (is_loading) {
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
}


<div style="margin: 0px;">
  @if (myForm) {
  <form [formGroup]="myForm" (ngSubmit)="onSubmit()" novalidate>


    <!--    <ng-container *ngIf="!is_loading">-->

    <div [hidden]="is_loading">

      <mat-card  style="width: 400px; margin-top: 20px; margin-left: 20px;">

        <mat-card-header>
          <h2>Campaign Group</h2>
        </mat-card-header>

        <mat-card-content>

          <mat-form-field style="margin-top: 15px; width: 100%">
            <mat-label>Campaign Group Name:</mat-label>
            <input matInput type="text" placeholder="e.g. foo" (focus)="onFocus()" formControlName="name">
            <mat-error style="font-size: 12px">Valid name required</mat-error>
          </mat-form-field>

          <mat-form-field style="margin-top: 15px; width: 100%">
            <mat-label>Parent Campaign Group</mat-label>
            <mat-select formControlName="campaign_group_parent_id" >
              @for (group of campaign_group_select_list; track group.id) {
                <mat-option [value]="group.id">
                  {{ group.name }}
                </mat-option>
              }
            </mat-select>
            <mat-error style="font-size: 12px">Please select a valid campaign group</mat-error>
          </mat-form-field>

          <div style="margin-top: 15px; width: 100%">
            <mat-slide-toggle formControlName="status" (change)="onFocus()">
              {{ myForm.get('status')?.value === true? 'Active' : 'Paused' }}
            </mat-slide-toggle>
          </div>

        </mat-card-content>


        <mat-card-actions>
          <div class="flex-container" style="margin-top: 10px;">
            <button mat-raised-button color="primary" [disabled]="!myForm.valid || is_loading" type="submit" style="margin: 15px">{{submit_text}}</button>
            <button mat-raised-button color="accent" [disabled]="is_loading" type="button" (click)="backToCampaignGroups()" style="margin: 15px">Cancel</button>
          </div>
        </mat-card-actions>

      </mat-card>



    </div>






    <!--    </ng-container>-->



  </form>
  }
</div>
